import { normalizeCfItems } from './dynamicContentUtils';
import { CfNode } from '../organisms/DynamicTabbedLayout/DynamicTabbedLayout.types';
import { getProcessEnvs } from '@marriott/mi-headless-utils';

const isMockCFDataEnabled = () => {
  // @ts-expect-error noPropertyAccessFromIndexSignature: webpack inlines direct env property access.
  const nextPublicMockCfData = process.env.NEXT_PUBLIC_USE_MOCK_CFDATA;
  // @ts-expect-error noPropertyAccessFromIndexSignature: webpack inlines direct env property access.
  const mockCfData = process.env.USE_MOCK_CFDATA;
  return nextPublicMockCfData === 'true' || mockCfData === 'true';
};

/**
 * Server-side CF fetcher with Basic Auth support.
 * Can consume either mock data or real AEM GraphQL responses.
 */
export async function fetchCFData(tabName: string, isAuthorMode: boolean): Promise<CfNode[]> {
  try {
    console.log(`[fetchCFData] Start for tabName: ${tabName}`);
    const isAuthorModeBool = String(isAuthorMode).toLowerCase() === 'true';
    console.log(`[fetchCFData] isAuthorMode: ${isAuthorModeBool}`);
    let nodes = [];

    if (isMockCFDataEnabled()) {
      // local mock import
      const { cfMockData } = await import('../organisms/DynamicTabbedLayout/cfMockContent.mock');
      nodes = cfMockData[tabName as keyof typeof cfMockData]?.cards ?? [];
      console.log(`[fetchCFData] CF nodes count from mock: ${nodes.length}`);
    } else {
      // real AEM GraphQL fetch
      const { NEXT_PUBLIC_AEM_PUBLISH } = getProcessEnvs();
      const AEM_GRAPHQL_BASE = !isAuthorModeBool ? NEXT_PUBLIC_AEM_PUBLISH : '';
      const AEM_GRAPHQL_QUERY_ROOT = process.env['AEM_GRAPHQL_QUERY_ROOT'] || 'mi-aem-common-spa/tabcollectionlist';
      const AEM_GRAPHQL_LOCALE = process.env['AEM_GRAPHQL_LOCALE'] || 'en-us';
      const AEM_GRAPHQL_BASIC_AUTH = process.env['NEXT_AEM_AUTH'];

      const tagsJson = JSON.stringify({
        _logOp: 'OR',
        _expressions: [{ value: `${tabName.toLowerCase()}`, _operator: 'CONTAINS' }],
      });

      const graphPath = `${AEM_GRAPHQL_QUERY_ROOT}${encodeURIComponent(
        `;tags=${tagsJson};locale=${AEM_GRAPHQL_LOCALE}`
      )}`;

      const url = `${AEM_GRAPHQL_BASE}/graphql/execute.json/${graphPath}`;
      console.log(`[fetchCFData] Fetching CF nodes from AEM url: ${url}`);

      const headers: Record<string, string> = { 'Content-Type': 'application/json' };
      if (AEM_GRAPHQL_BASIC_AUTH) headers['Authorization'] = AEM_GRAPHQL_BASIC_AUTH;
      console.log(`[fetchCFData] headers: ${JSON.stringify(headers)}`);
      const aemRes = await fetch(url, {
        method: 'GET',
        headers,
      });

      if (!aemRes.ok) throw new Error(`[fetchCFData] AEM CF fetch failed: ${aemRes.status} ${aemRes.statusText}`);

      const json = await aemRes.json();
      nodes = json?.data?.tabCollectionList?.items[0]?.cards ?? [];
      console.log(`[fetchCFData] CF nodes count from AEM: ${nodes.length} for tabName: ${tabName}`);
    }
    const normalized = normalizeCfItems(nodes, tabName);
    console.log(`[fetchCFData] Normalized CF nodes count: ${normalized.length} for tabName: ${tabName}`);
    return normalized;
  } catch (err) {
    console.error('[fetchCFData] Error fetching CF nodes:', err);
    return [];
  }
}
